import axios from '../../utils/axios';

const Slack = {
    getInstallUrl: async () => axios.get('/integrations/slack/installation-url')
};

export default Slack;
